import {
  AssembleiaIcon,
  CircleInfo,
  EditIcon,
  ErrorIcon,
  PlayIcon,
  SyncIcon,
} from 'components/Icons';
import Breadcrumb, {
  IBreadCrumbItem,
} from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import AssembleiaDateTime from 'components/__SHARED__/AssembleiaDateTime';
import InfoCard from 'components/__SHARED__/LabelValueCard/LabelValueCard';
import Page from 'components/__SHARED__/PrivateContainer';
import { parseISO } from 'date-fns';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import {
  AssessorRoutePath,
  AssessorTransmissaoRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import {
  Button,
  ButtonThemes,
  Col,
  Etiqueta,
  EtiquetasStyle,
  Modal,
  ModalSizes,
  NotebookIcon,
  PhonePlusIcon,
  RefreshIcon,
  Row,
  Title,
  TooltipPosition,
} from 'plataforma-fundacao-componentes';
import React, { Fragment, useCallback, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { openModal } from 'store/modules/ModalActions';
import Context from '../../Context';
import Pautas from '../../Pautas';
import useStyle from '../../style';

import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import styles from './styles.module.scss';

export default function PautasDoEvento() {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    evento,
    loadingEvento,
    bloqueando,
    bloquearEvento,
    alterarSituacao,
    usuario,
    presencas,
    atualizarPresencas,
    atualizandoPresencas,
    editarTransmissao,
    registraQuorum,
    startVoting,
    startingVoting,
    registrandoQuorum,
    pagePautas,
    setPagePautas,
    loadPautas,
  } = useContext(Context);

  const isAGN = useMemo(() => {
    if (!evento?.tipo) return false;
    return [AssembleiaTipo.Nucleo, AssembleiaTipo.Reuniao].includes(
      evento.tipo
    );
  }, [evento]);

  const classes = useStyle({ isAGN });

  const eventoSituacao = useMemo(() => {
    if (loadingEvento) {
      return translation.AssembleiaAssessorRoute.carregando;
    }
    return translation.AssembleiaStatus[`${evento?.status || 0}`];
  }, [evento, loadingEvento]);

  const needQuorumRegister = useMemo(() => {
    return (
      evento?.status === AssembleiaStatus.Live &&
      evento.tipo !== AssembleiaTipo.Nucleo &&
      evento.tipo !== AssembleiaTipo.Reuniao &&
      !evento.existeQuorum
    );
  }, [evento]);

  const start = useMemo(() => {
    return (
      evento?.status === AssembleiaStatus.Live &&
      (evento.tipo === AssembleiaTipo.Nucleo ||
        evento.tipo === AssembleiaTipo.Reuniao) &&
      !evento.flagIniciarVotacaoDigital
    );
  }, [evento]);

  const openTransmissao = useCallback(() => {
    if (!evento?.urlTransmissao) return;
    const winUrl =
      AssessorTransmissaoRoutePath + `?url=${evento.urlTransmissao}`;
    const win = window.open(winUrl, '_blank');
    win?.focus();
  }, [evento]);

  const infoModal = (title: string, description: React.ReactNode | string) => {
    const mKey = `alert${getUniqueKey()}`;
    dispatch(
      openModal(Modal, {
        preventMaskExit: true,
        size: ModalSizes.Large,
        modalKey: mKey,
        title: title,
        children: <p className={classes.contentModal}>{description}</p>,
      })
    );
  };

  const eventoNome = useMemo(() => {
    if (loadingEvento) {
      return translation.AssembleiaAssessorRoute.carregando;
    }
    return evento?.nome || '';
  }, [evento, loadingEvento]);

  const breadcrumb = useMemo(
    (): IBreadCrumbItem[] => [
      { nome: translation.MainRoute.title, url: AssessorRoutePath },
      { nome: eventoNome },
    ],
    [eventoNome]
  );

  const eventType = useMemo(() => {
    switch (evento!?.modo!) {
      case AssemblyModalitiesNumber.OFFLINE:
        return '100% presencial';
      case AssemblyModalitiesNumber.HIBRIDO_PRESENCIAL_DIGITAL:
        return 'Assíncrono - Presencial e digital';
      case AssemblyModalitiesNumber.HIBRIDO_DIGITAL_AGENCIA:
        return 'Simultâneo - Digital e agência';
      case AssemblyModalitiesNumber.ONLINE:
        return '100% digital';
      case AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO:
        return 'Simultâneo - Digital e presencial';
    }
  }, [evento]);

  const eventIcon = useMemo(() => {
    switch (evento!?.modo!) {
      case AssemblyModalitiesNumber.ONLINE:
        return <NotebookIcon />;
      default:
        return <PhonePlusIcon />;
    }
  }, [evento]);

  return (
    <Fragment>
      <Page
        header={
          <Row>
            <Col>
              <Title
                showBackButton={true}
                onBackClick={() => {
                  history!?.push(AssessorRoutePath);
                }}
                rightElement={
                  <Etiqueta
                    theme={EtiquetasStyle.Edicao}
                    label={eventType}
                    icon={eventIcon}
                    fitContent
                  />
                }
              >
                {eventoNome}
              </Title>
            </Col>
            <Col noPaddingTop>
              <Breadcrumb itens={breadcrumb} />
            </Col>
          </Row>
        }
        contentClassName={styles.root}
      >
        <Row>
          <Row style={{ alignItems: 'center' }}>
            <Col cols={[12, 4, 3, 3, 2]}>
              <div>
                {translation.AssembleiaAssessorRoute.situacao(eventoSituacao)}
              </div>
            </Col>
            <Col cols={[12, 8, 6, 6, 8]}>
              {evento?.dataEvento && (
                <AssembleiaDateTime
                  date={parseISO(evento.dataEvento)}
                  alignStart
                />
              )}
            </Col>
            <Col cols={[12, 12, 12, 12, 12]} buttonActionsCol end>
              {((usuario?.perfil.id === 'pertencer_consulta' &&
                !usuario?.perfil.assessorRoute.assembleias.alterarSituacao &&
                evento?.tipo === 'REU') ||
                usuario?.perfil.assessorRoute.assembleias.alterarSituacao) &&
                !loadingEvento && (
                  <React.Fragment>
                    {!evento?.dataBloqueio && (
                      <Button
                        theme={ButtonThemes.Danger}
                        leftIcon={
                          bloqueando ? <SyncIcon animated /> : <ErrorIcon />
                        }
                        onClick={bloquearEvento}
                      >
                        {translation.AssembleiaAssessorRoute.bloqueiaEvento}
                      </Button>
                    )}
                    {needQuorumRegister && (
                      <Button
                        theme={ButtonThemes.Secondary}
                        onClick={
                          needQuorumRegister ? registraQuorum : startVoting
                        }
                        leftIcon={
                          registrandoQuorum || startingVoting ? (
                            <SyncIcon animated />
                          ) : (
                            <AssembleiaIcon />
                          )
                        }
                      >
                        {
                          translation.AssembleiaAssessorRoute
                            .buttonRegistrarQuorum
                        }
                      </Button>
                    )}
                    {start && (
                      <Button
                        theme={ButtonThemes.Secondary}
                        onClick={
                          needQuorumRegister ? registraQuorum : startVoting
                        }
                        leftIcon={
                          registrandoQuorum || startingVoting ? (
                            <SyncIcon animated />
                          ) : (
                            <AssembleiaIcon />
                          )
                        }
                      >
                        {
                          translation.AssembleiaAssessorRoute
                            .buttonRegistrarQuorum
                        }
                      </Button>
                    )}
                    {evento?.emFinalizacao && (
                      <div
                        tooltip-text={
                          translation.AssembleiaAssessorRoute.infoEmFinalizacao
                        }
                        tooltip-position={TooltipPosition.Top}
                      >
                        <CircleInfo />
                      </div>
                    )}
                    <Button
                      theme={ButtonThemes.Primary}
                      color='primary'
                      onClick={alterarSituacao}
                      leftIcon={<EditIcon />}
                      disabled={evento?.emFinalizacao}
                    >
                      {evento?.emFinalizacao
                        ? translation.AssembleiaAssessorRoute
                            .buttonEmFinalizacao
                        : translation.AssembleiaAssessorRoute
                            .buttonAlterarSituacao}
                    </Button>
                  </React.Fragment>
                )}
            </Col>
          </Row>
          <Col style={{ marginTop: '16px' }}>
            <Button
              data-testid={'assessor-atualizar-participantes-button'}
              theme={ButtonThemes.Secondary}
              onClick={atualizarPresencas}
              leftIcon={<RefreshIcon animate={false} />}
              disabled={atualizandoPresencas}
              loading={atualizandoPresencas}
            >
              {translation.AssembleiaAssessorRoute.buttonAtualizarParticipantes}
            </Button>
          </Col>
          <Row className={styles.cards}>
            <Col gap={14}>
              <InfoCard
                label={
                  translation.AssembleiaAssessorRoute[
                    evento?.urlTransmissao
                      ? 'buttonAssistirTransmissao'
                      : 'buttonEditarTransmissao'
                  ]
                }
                value={
                  loadingEvento ? (
                    <SyncIcon animated className={classes.labelValueIcon} />
                  ) : (
                    <PlayIcon className={classes.labelValueIcon} />
                  )
                }
                button
                onClick={
                  evento?.urlTransmissao ? openTransmissao : editarTransmissao
                }
              />
              <InfoCard
                label={
                  translation.AssembleiaAssessorRoute.infoCardLabel
                    .quorumAtingido
                }
                infoDescription={() => {
                  infoModal(
                    translation.AssembleiaAssessorRoute.infoCardLabel
                      .quorumAtingido,
                    <>
                      <b>
                        {
                          translation.AssembleiaAssessorRoute.CardModal
                            .quorumAtingidoBold1
                        }
                      </b>
                      {
                        translation.AssembleiaAssessorRoute.CardModal
                          .quorumAtingido1
                      }
                      <b>
                        {
                          translation.AssembleiaAssessorRoute.CardModal
                            .quorumAtingidoBold2
                        }
                      </b>
                      {
                        translation.AssembleiaAssessorRoute.CardModal
                          .quorumAtingido2
                      }
                    </>
                  );
                }}
                value={
                  loadingEvento || atualizandoPresencas
                    ? '-'
                    : translation.AssembleiaAssessorRoute.quorumAtingido[
                        `${presencas.quorumAtingido}`
                      ]
                }
              />
              <InfoCard
                label={
                  translation.AssembleiaAssessorRoute.infoCardLabel
                    .participantes
                }
                infoDescription={() => {
                  infoModal(
                    translation.AssembleiaAssessorRoute.infoCardLabel
                      .participantes,
                    translation.AssembleiaAssessorRoute.CardModal
                      .participantesOnline
                  );
                }}
                value={
                  loadingEvento || atualizandoPresencas
                    ? '-'
                    : presencas.quantidadePessoasOnline
                }
              />
              <InfoCard
                label={translation.AssembleiaAssessorRoute.infoCardLabel.contas}
                infoDescription={() => {
                  infoModal(
                    translation.AssembleiaAssessorRoute.infoCardLabel.contas,
                    translation.AssembleiaAssessorRoute.CardModal.associados
                  );
                }}
                value={
                  loadingEvento || atualizandoPresencas
                    ? '-'
                    : presencas.contasCapital
                }
              />
              {isAGN && (
                <InfoCard
                  label={
                    translation.AssembleiaAssessorRoute.infoCardLabel.aptos
                  }
                  infoDescription={() => {
                    infoModal(
                      translation.AssembleiaAssessorRoute.infoCardLabel.aptos,
                      translation.AssembleiaAssessorRoute.CardModal
                        .associadosAptos
                    );
                  }}
                  value={
                    loadingEvento || atualizandoPresencas
                      ? '-'
                      : presencas.presentesAptos
                  }
                />
              )}
              <InfoCard
                label={
                  translation.AssembleiaAssessorRoute.infoCardLabel.presencas
                }
                infoDescription={() => {
                  infoModal(
                    translation.AssembleiaAssessorRoute.infoCardLabel.presencas,
                    translation.AssembleiaAssessorRoute.CardModal
                      .pessoasPresentes
                  );
                }}
                value={
                  loadingEvento || atualizandoPresencas
                    ? '-'
                    : presencas.presentes
                }
              />
              <InfoCard
                label={'Convidados'}
                infoDescription={() => {
                  infoModal(
                    'Convidados presentes',
                    'Pessoas que estão assistindo a assembleia, mas não constam na lista de convocados deste evento. Ou seja, não possuem direito a voto e nem confirmaram presença. Verificar em presentes > convidados a lista das pessoas.'
                  );
                }}
                value={
                  loadingEvento || atualizandoPresencas
                    ? '-'
                    : presencas.convidados
                }
              />
            </Col>
          </Row>
          {usuario?.perfil.assessorRoute.assembleias.pautas.ver &&
            evento?.id && (
              <Row>
                <Col>
                  <Pautas
                    idEvento={evento.id}
                    needQuorumRegister={needQuorumRegister}
                    currentPage={pagePautas + 1}
                    onChangePage={(value: number) => {
                      if (value - 1 !== pagePautas) {
                        setPagePautas(value - 1);
                      } else {
                        loadPautas(evento!?.id);
                      }
                    }}
                    tipo={evento.tipo}
                  />
                </Col>
              </Row>
            )}
        </Row>
      </Page>
    </Fragment>
  );
}
